import {
  IFillDataWizardSell,
  TKeyOfDataWizardSell,
  TStringKeysOfIFillDataWizardSell,
} from "../..";
import DoNotKnowPriceSellStep_1 from "../doNotNowPrice/sell/step_1";
import DoNotKnowPriceSellStep_2 from "../doNotNowPrice/sell/step_2";
import DoNotKnowPriceSellStep_3 from "../doNotNowPrice/sell/step_3";
import DoNotKnowPriceSellStep_4 from "../doNotNowPrice/sell/step_4";
import DoNotKnowPriceSellStep_5 from "../doNotNowPrice/sell/step_5";
import DoNotKnowPriceSellStep_6 from "../doNotNowPrice/sell/step_6";

const getDoNotKnowSellSteps = (
  data: IFillDataWizardSell,
  onReset: (keys: TKeyOfDataWizardSell[], data?: number[]) => void,
  handleChangeDataString: (
    data: string,
    key: TStringKeysOfIFillDataWizardSell
  ) => void,
  disabledAndPrev: {
    isNextStep_offersForClient: boolean;
    isNextStep_communicationType: boolean;
    isNextStep_viewRealtorParticipation: boolean;
    isNextStep_timeIntervalTypeCommunication: boolean;
  }
) => {
  const {
    isNextStep_offersForClient,
    isNextStep_communicationType,
    isNextStep_viewRealtorParticipation,
    isNextStep_timeIntervalTypeCommunication,
  } = disabledAndPrev;

  return [
    <DoNotKnowPriceSellStep_1 />,
    <DoNotKnowPriceSellStep_2
      data={data.communicationType}
      isNextStepDisabled={isNextStep_communicationType}
      onChange={handleChangeDataString}
      onReset={onReset}
    />,
    <DoNotKnowPriceSellStep_3
      onChange={handleChangeDataString}
      data={data.timeIntervalTypeCommunication}
      isNextStepDisabled={isNextStep_timeIntervalTypeCommunication}
      onReset={onReset}
    />,
    <DoNotKnowPriceSellStep_4
      onChange={handleChangeDataString}
      data={data.viewRealtorParticipation}
      isNextStepDisabled={isNextStep_viewRealtorParticipation}
      onReset={onReset}
    />,
    <DoNotKnowPriceSellStep_5
      onChange={handleChangeDataString}
      data={data.offersForClient}
      isNextStepDisabled={isNextStep_offersForClient}
      onReset={onReset}
    />,
    <DoNotKnowPriceSellStep_6 data={data} />,
  ];
};

export default getDoNotKnowSellSteps;
